/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FocusEventHandler, useState } from 'react'
import { Form, Input } from 'antd'
import classnames from 'classnames'
import { DEFAULT_INPUT_LENGTH, LABEL_ALIGN_TYPE } from '../form.constants'
import { formRules, Validator } from '../form.utils'
import '../form.scss'
import FloatingLabel from '../floating-lable/floating-lable'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'

export interface InputPasswordProps {
  maxLength?: number
  min?: {
    value: number
    message: string
  }
  max?: {
    value: number
    message: string
  }
  isAllowClear?: boolean
  isDisabled?: boolean
  label?: string | any
  name?: string | any
  isRequired?: boolean
  labelAlign?: keyof typeof LABEL_ALIGN_TYPE
  pattern?: RegExp
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  inputContainerStyle?: string
  validateTrigger?: string | string[]
  validator?: Validator
  patternMessage?: string
  prefix?: React.ReactNode
  placeholder?: string
  value?: string | ReadonlyArray<string> | number | undefined
  onBlur?: FocusEventHandler<HTMLInputElement>
  isURL?: boolean
  isEmail?: boolean
}

const InputPassword: React.FC<InputPasswordProps> = (
  props: InputPasswordProps
) => {
  const {
    min,
    max,
    label,
    name,
    labelAlign,
    isRequired,
    validator,
    onChange,
    className,
    pattern,
    patternMessage,
    isDisabled,
    isAllowClear,
    maxLength,
    validateTrigger,
    prefix,
    value,
    inputContainerStyle,
    isURL = false,
    isEmail = false,
  } = props

  const [active, setActive] = useState(false)

  const onBlur = () => {
    setActive(false)
  }

  const onFocus = () => {
    setActive(true)
  }
  return (
    <FloatingLabel active={active} labelText={label} name={name}>
      <Form.Item
        // label={label}
        name={name}
        labelAlign={labelAlign}
        validateTrigger={validateTrigger}
        className={classnames('block', className)}
        rules={formRules(
          label,
          isRequired,
          validator,
          pattern,
          patternMessage,
          min,
          max,
          isURL,
          isEmail
        )}
        validateFirst={true}
      >
        <Input.Password
          iconRender={(passwordVisible) =>
            passwordVisible ? (
              <div>
                <EyeTwoTone /> <span>{'Hide'}</span>
              </div>
            ) : (
              <div>
                <EyeInvisibleOutlined /> <span>{'Show'}</span>
              </div>
            )
          }
          suffix={<div>show</div>}
          className={classnames('form-item-input-width', inputContainerStyle)}
          disabled={isDisabled}
          id={name}
          onChange={onChange}
          allowClear={isAllowClear}
          maxLength={maxLength || DEFAULT_INPUT_LENGTH}
          prefix={prefix}
          // placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          onFocus={onFocus}
          type={isEmail ? 'email' : 'text'}
        />
      </Form.Item>
    </FloatingLabel>
  )
}

export default InputPassword
